import Aura from '@primevue/themes/aura'
import PrimeVue from 'primevue/config'
import { createApp } from 'vue'
import App from './App.vue'

const env = process.env.NODE_ENV
const development = env === 'development'
if (development) {
  import('./assets/variables.css')
  import('./assets/main.css')
}

import { handleInvalidLanguage, setLocale } from './composables/helpers'

const elements = [
  {
    element: '#accosbar',
    properties: [
      { name: 'pid', type: 'int' },
      { name: 'l', type: 'string' },
      { name: 'areaid', type: 'int' },
      { name: 'enablemini', type: 'boolean' },
      { name: 'themeid', type: 'int' }
    ]
  },
  {
    element: '#filterpage',
    properties: [
      { name: 'pid', type: 'int' },
      { name: 'l', type: 'string' },
      { name: 'mapkey', type: 'string' },
      { name: 'mapid', type: 'string' }
    ]
  },
  {
    element: '#enquirybar',
    properties: [
      { name: 'pid', type: 'int' },
      { name: 'l', type: 'string' },
      { name: 'accosListPageFilter', type: 'string' }
    ]
  },
  {
    element: '#enquirypage',
    properties: [
      { name: 'pid', type: 'int' },
      { name: 'l', type: 'string' },
      { name: 'cid', type: 'int' }
    ]
  }
]

const getPropertyValue = (el: any, name: string, type: string) => {
  switch (type) {
    case 'int':
      return parseInt(el.getAttribute(name))
    case 'string':
      return el.getAttribute(name)
    case 'number[]':
      return JSON.parse(el.getAttribute(name)) as number[]
    case 'boolean':
      return el.getAttribute(name) === 'true'
    default:
      throw new Error(`Invalid property type: ${type}`)
  }
}

for (const item of elements) {
  const el = document.querySelector(item.element)

  if (!el) {
    continue
  }

  const properties: any = {}

  for (const p of item.properties) {
    const value = getPropertyValue(el, p.name, p.type)
    properties[p.name] = value
  }

  handleInvalidLanguage(properties.l)
  mountApp(
    item.element,
    properties.pid,
    properties.l,
    properties.areaid,
    properties.mapkey,
    properties.mapid,
    properties.cid,
    properties.accosListPageFilter,
    properties.enablemini,
    properties.themeid
  )
}

function mountApp(
  selector: string,
  pid: number,
  l: string,
  areaid: number,
  mapkey?: string,
  mapid?: string,
  cid?: number,
  accosListPageFilter?: string,
  enablemini?: boolean,
  themeid?: number
) {
  const componentType = selector.replace('#', '')
  const app = createApp(App, { componentType, pid, l, areaid, mapkey, mapid, cid, accosListPageFilter, enablemini, themeid })
  app.use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primevue',
          order: 'tailwind-base, primevue, tailwind-utilities'
        }
      }
    },
    locale: setLocale(l)
  })
  app.config.globalProperties.$window = window
  app.config.globalProperties.$scom = window.scom
  app.mount(selector)
}
